export default __webpack_public_path__ + "static/media/icon-selo-carta.87a360ef.svg";